<template>
  <div class="login-container">
    <div class="login-header">
      <img src="@/assets/logo.png" alt="Logo" class="logo" />
      <h2 class="title">教育平台登录</h2>
    </div>

    <div class="login-form">
      <!-- 手机号输入 -->
      <div class="form-item">
        <label class="form-label">手机号</label>
        <van-field v-model="loginForm.phone" type="tel" placeholder="请输入手机号" maxlength="11"
          :error-message="errors.phone" @input="onPhoneInput" @keyup.enter="focusPassword" ref="phoneInput" clearable />
      </div>

      <!-- 密码输入 -->
      <div class="form-item">
        <label class="form-label">密码</label>
        <van-field v-model="loginForm.password" :type="showPassword ? 'text' : 'password'" placeholder="请输入密码"
          :error-message="errors.password" right-icon="eye-o" @click-right-icon="showPassword = !showPassword"
          ref="passwordInput" @input="onPasswordInput" @keyup.enter="handleLogin" clearable />
      </div>

      <!-- 登录按钮 -->
      <van-button type="primary" class="login-btn" @click="handleLogin" :loading="loading" :disabled="loading">
        登录
      </van-button>

    </div>
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue';
import { useRouter } from 'vue-router';
import { sidelineLogin } from '@/api/auth';
import { setToken } from '@/utils/authUtils';
import { message } from 'ant-design-vue';

const router = useRouter();
const passwordInput = ref(null);
const showPassword = ref(false);
const loading = ref(false);
const loginForm = reactive({
  phone: '',
  password: ''
});
const errors = reactive({
  phone: '',
  password: ''
});

function onPhoneInput() {
  if (errors.phone) {
    errors.phone = '';
  }
}

function onPasswordInput() {
  if (errors.password) {
    errors.password = '';
  }
}

function focusPassword() {
  if (loginForm.phone) {
    passwordInput.value?.focus();
  }
}

function validatePhone(phone) {
  const phoneRegex = /^1[3-9]\d{9}$/;
  return phoneRegex.test(phone);
}

function clearErrors() {
  errors.phone = '';
  errors.password = '';
}

function validateForm() {
  clearErrors();
  let isValid = true;

  if (!loginForm.phone) {
    errors.phone = '请输入手机号';
    isValid = false;
  } else if (!validatePhone(loginForm.phone)) {
    errors.phone = '请输入正确的手机号格式';
    isValid = false;
  }

  if (!loginForm.password) {
    errors.password = '请输入密码';
    isValid = false;
  }
  return isValid;
}

function handleLogin() {
  if (!validateForm()) {
    return;
  }

  loading.value = true;

  sidelineLogin({
    username: loginForm.phone,
    password: loginForm.password,
    clientId: 'bc84e6c82e5f4bea008575701fd32ea5',
    grantType: 'password'
  })
    .then(res => {
      if (res.access_token) {
        setToken(res.access_token);
        message.success('登录成功');
        router.push('/');
      }
    })
    .catch(error => {
      console.error('登录失败', error);

      if (error.response) {
        const { status, data } = error.response;

        if (status === 401) {
          errors.password = data?.msg || '手机号或密码错误';
          message.error(errors.password);
          passwordInput.value?.focus();
        } else if (status === 429) {
          message.error('登录过于频繁，请稍后再试');
        } else if (status >= 500) {
          message.error('服务器繁忙，请稍后再试');
        } else {
          message.error(data?.msg || '登录失败，请检查输入信息');
        }
      } else if (error.request) {
        message.error('网络连接失败，请检查您的网络');
      } else {
        message.error('请求配置错误');
      }
    })
    .finally(() => {
      loading.value = false;
    });
}
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  padding: 20px;
  background-color: #f8f8f8;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* 添加背景渐变效果 */
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

/* 适配小屏幕设备 */
@media (max-width: 480px) {
  .login-container {
    padding: 15px;
  }

  .login-form {
    padding: 20px;
  }

  .title {
    font-size: 20px;
  }
}

.login-header {
  text-align: center;
  margin-bottom: 40px;
}

.logo {
  width: 80px;
  height: 80px;
  margin-bottom: 20px;
}

.title {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.login-form {
  width: 100%;
  max-width: 400px;
  background-color: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.form-item {
  margin-bottom: 20px;
}

.form-label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

.login-btn {
  width: 100%;
  margin-top: 30px;
  height: 45px;
  font-size: 16px;
}

.login-footer {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.footer-link {
  font-size: 14px;
  color: #1989fa;
}
</style>